import FormInput from '@/app/components/Input/FormInput';
import { useCurrencyTranslation } from '@/app/hooks/useCurrencyTranslation';
import { useAbGroup } from '@/app/providers/ConfigProvider';
import { useProjectData } from '@/app/providers/ProjectProvider';
import {
  getTipOptionsForHigherAmountBasedOnGroup,
  getTipOptionsForLowerAmountBasedOnGroup,
} from '@/app/utils/abTesting/checkout-form';
import { getCountryConfig } from '@/app/utils/countryConfig';
import { getCalculatedTip } from '@/app/utils/getCalculatedTip';
import { useField } from 'formik';
import { useMemo } from 'react';

type CustomAmountProps = {
  label: string;
  isTipTouched: boolean;
  onTipChange: (value: [string, number]) => void;
  className?: string;
  currentTip: number;
};

const countryConfig = getCountryConfig();

const AMOUNT_INPUT_NAME = 'amount';

export const CustomAmount = ({ label, onTipChange, className, currentTip }: CustomAmountProps) => {
  const currencyTranslation = useCurrencyTranslation();
  const abGroup = useAbGroup();
  const [field] = useField(AMOUNT_INPUT_NAME);
  const { project } = useProjectData();

  const tipOptionsForHighDonation = useMemo(() => {
    return getTipOptionsForHigherAmountBasedOnGroup(abGroup).map((option) => option.value);
  }, [abGroup]);

  const tipOptionsForLowDonation = useMemo(() => {
    return getTipOptionsForLowerAmountBasedOnGroup(abGroup).map((option) => option.value);
  }, [abGroup]);

  return (
    <FormInput
      className={className}
      type="number"
      name={AMOUNT_INPUT_NAME}
      label={label}
      after={currencyTranslation}
      onChange={(value) => {
        if (project.settings.hasTipsDisabled) {
          return;
        }
        onTipChange(
          getCalculatedTip({
            currentTip,
            abGroup,
            amount: Number(value),
            tipBreakpoint: countryConfig.donationFormCommon.tipBreakpointForDefaultValue,
            tipOptionsForHighDonation,
            tipOptionsForLowDonation,
            previousAmount: Number(field.value),
            defaultTipForAmountAboveBreakpoint: countryConfig.donationFormCommon.defaultTipForAmountAboveBreakpoint,
            defaultTipForAmountBelowBreakpoint: countryConfig.donationFormCommon.defaultTipForAmountBelowBreakpoint,
          }),
        );
      }}
    />
  );
};
